import './CTASection.css'

export default function CTASection() {
  return (
    <section className="cta-section" id="contato">
      <div className="cta-inner">
        <h2>Vamos transformar seu desafio em uma solução tecnológica?</h2>
        <p>Conte-nos sobre o seu projeto. Em até 24 horas retornamos com uma proposta de próximos passos.</p>
        <a href="https://wa.link/gptqwc" target="_blank" rel="noopener" className="btn-primary" style={{ fontSize: 15, padding: '15px 32px', margin: '0 auto', display: 'inline-flex' }}>
          💬 Iniciar conversa
        </a>
      </div>
    </section>
  )
}
